export var themeColors = {
    darkGrey: '#3B3D40',
    midGrey1: '#81858D',
    midGrey2: '#6D7078',
    midGrey3: '#5A5D64',
    midGrey4: '#BBBCBD',
    midGrey5: '#5e5a61',
    lightGrey1: '#F2F3F4',
    lightGrey2: '#DDE1E3',
    lightGrey3: '#CFD3D6',
    blue: '#0A74C7',
    darkBlue: '#06508A',
    lightBlue: '#CEE3F4',
    lightBlue2: '#73BDF5',
    messageIconBlue: '#096AB3',
    white: '#FFFFFF',
    black: '#000000',
    // TD Brand Colors
    brandLight: '#77CB1F',
    brandDark: '#589000',
    // Buttons
    primary: '#E96F0B',
    primaryHover: '#BA5808',
    secondary: '#0A74C7',
    secondaryHover: '#06508A',
    // Info Colors
    success: '#4B8400',
    error: '#E31F2D',
    warning: '#FF8800',
    info: '#CFD3D6',
    // Active/Deactive
    active: '#4B8400',
    deactivated: '#6D7078',
    // Style
    aluminium: '#A8ABB1',
    // override TD Brand Colors defaults
    brandPrimary: '#E96F0B',
    brandSecondary: '#0A74C7',
    purple: '#FF00FF',
    messageOrange: '#F9E1CD',
    messageBrandLight: '#E1EECF',
    messageError: '#F6D0D3',
    // Button colors
    buttonBlue: '#0A74C7',
    buttonDarkBlue: '#004996',
    buttonGray: '#6D7078',
    buttonLightGray: '#DDE1E3',
    buttonDarkGray: '#3B3D40',
    buttonWhite: '#FFFFFF'
};
export function renderCssVariables() {
    // Note, when using RGBA hexadecimal notation, i.e. #RRGGBBAA, where AA is the alpha value, use 33 for 20%, 66 for 40%, and 80 for 50%
    var style = document.createElement('style');
    style.innerHTML = "\n    :root {\n        --studio-darkGrey: ".concat(themeColors.darkGrey, ";\n        --studio-midGrey1: ").concat(themeColors.midGrey1, ";\n        --studio-midGrey2: ").concat(themeColors.midGrey2, ";\n        --studio-midGrey4: ").concat(themeColors.midGrey4, ";\n        --studio-midGrey5: ").concat(themeColors.midGrey5, ";\n        --studio-lightGrey1: ").concat(themeColors.lightGrey1, ";\n        --studio-lightGrey2: ").concat(themeColors.lightGrey2, ";\n        --studio-lightGrey3: ").concat(themeColors.lightGrey3, ";\n        --studio-blue: ").concat(themeColors.blue, ";\n        --studio-darkBlue: ").concat(themeColors.darkBlue, ";\n        --studio-lightBlue: ").concat(themeColors.lightBlue, ";\n        --studio-lightBlue2: ").concat(themeColors.lightBlue2, ";\n        --studio-messageIconBlue: ").concat(themeColors.messageIconBlue, ";\n        --studio-white: ").concat(themeColors.white, ";\n        --studio-black: ").concat(themeColors.black, ";\n\t\t\t\t--studio-blackAlpha10: ").concat(themeColors.black, "20;\n        --studio-blackAlpha20: ").concat(themeColors.black, "33;\n        --studio-blackAlpha40: ").concat(themeColors.black, "66;\n        --studio-blueAlpha40: ").concat(themeColors.blue, "66;\n        --studio-brandLight: ").concat(themeColors.brandLight, ";\n        --studio-brandDark: ").concat(themeColors.brandDark, ";\n        --studio-secondary: ").concat(themeColors.secondary, ";\n        --studio-error: ").concat(themeColors.error, ";\n        --studio-warning: ").concat(themeColors.warning, ";\n        --studio-active: ").concat(themeColors.active, ";\n        --studio-brandPrimary: ").concat(themeColors.brandPrimary, ";\n        --studio-brandSecondary: ").concat(themeColors.brandSecondary, ";\n        --studio-purple: ").concat(themeColors.purple, ";\n        --studio-buttonBlue: ").concat(themeColors.buttonBlue, ";\n        --studio-buttonDarkBlue: ").concat(themeColors.buttonDarkBlue, ";\n        --studio-buttonDarkGray: ").concat(themeColors.buttonDarkGray, ";\n        --studio-buttonGray: ").concat(themeColors.buttonGray, ";\n        --studio-buttonLightGray: ").concat(themeColors.buttonLightGray, ";\n        --studio-buttonWhite: ").concat(themeColors.buttonWhite, ";\n    }");
    var styleRef = document.head.appendChild(style);
    return styleRef;
}
